import { initAll } from "../node_modules/govuk-frontend/dist/govuk/all";

initAll()